(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["regear-guide-story"] && !Shopify.designMode) return;
  try {
    (() => {
  function enhance(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const content = root.querySelector('[data-story-content]');
    const nav = root.querySelector('[data-story-nav]');
    const children = [...content.childNodes];
    const opening = document.createElement('div');
    opening.className = 'rg-story__opening';
    content.prepend(opening);
    let body = opening, index = 0;
    children.forEach(node => {
      if (node.nodeType === 1 && node.tagName === 'H2') {
        index++;
        const chapter = document.createElement('section');
        chapter.className = 'rg-story__chapter';
        const text = node.textContent.trim();
        if (/compatibility and adjustment|Bindings and mounting|Before leaving/i.test(text)) chapter.classList.add('rg-story__chapter--note');
        if (/resources|Related buyer guides|Browse/i.test(text)) chapter.classList.add('rg-story__chapter--links');
        if (!node.id) node.id = root.id + '-chapter-' + index;
        node.tabIndex = -1;
        chapter.setAttribute('aria-labelledby', node.id);
        const heading = document.createElement('div');
        heading.className = 'rg-story__chapter-heading';
        const number = document.createElement('span');
        number.className = 'rg-story__number';
        number.setAttribute('aria-hidden','true');
        number.textContent = String(index).padStart(2,'0');
        heading.append(number, node);
        body = document.createElement('div');
        body.className = 'rg-story__chapter-body';
        chapter.append(heading,body);
        content.append(chapter);
        const link = document.createElement('a');
        link.href = '#' + node.id;
        const count = document.createElement('span');
        count.setAttribute('aria-hidden','true');
        count.textContent = String(index).padStart(2,'0');
        link.append(count,document.createTextNode(text));
        link.addEventListener('click', () => {
          nav.querySelectorAll('[aria-current]').forEach(a=>a.removeAttribute('aria-current'));
          link.setAttribute('aria-current','location');
          requestAnimationFrame(()=>node.focus({preventScroll:true}));
        });
        nav.append(link);
      } else body.append(node);
    });
    const overview = opening.querySelector('figure:has(img)');
    const firstChapter = content.querySelector('.rg-story__chapter-body');
    if (overview && firstChapter) firstChapter.append(overview);
    if (!opening.textContent.trim() && !opening.querySelector('img,svg')) opening.remove();
    root.querySelector('.rg-story__sidebar').hidden = !index;
  }
  if (!customElements.get('regear-guide-story')) customElements.define('regear-guide-story',class extends HTMLElement { connectedCallback(){enhance(this);} });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["regear-mobile-brand-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('regear-brand-navigation')) {
    customElements.define('regear-brand-navigation', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.filter = () => {
          const query = this.input.value.trim().toLocaleLowerCase();
          let matches = 0;
          this.querySelectorAll('[data-brand-name]').forEach(item => {
            item.hidden = !item.dataset.brandName.toLocaleLowerCase().includes(query);
            if (!item.hidden) matches++;
          });
          this.querySelector('[data-brand-empty]').hidden = matches > 0;
        };
        this.input.addEventListener('input', this.filter);
        this.filter();
      }
      disconnectedCallback() {
        this.input?.removeEventListener('input', this.filter);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
